module.exports = __webpack_public_path__ + "static/media/chair2left.8371394a.png";